import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-pencil',
  templateUrl: './edit-pencil.component.html',
  styleUrls: ['./edit-pencil.component.scss']
})
export class EditPencilComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
